export default __webpack_public_path__ + "static/media/storiesmc.3ae68283.svg";